var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5C1.17125 0.5 0.5 1.17125 0.5 2V11.75C0.5 12.164 0.836 12.5 1.25 12.5C1.664 12.5 2 12.164 2 11.75V2H11.75C12.164 2 12.5 1.664 12.5 1.25C12.5 0.836 12.164 0.5 11.75 0.5H2ZM5 3.5C4.17125 3.5 3.5 4.17125 3.5 5V14C3.5 14.8287 4.17125 15.5 5 15.5H14C14.8287 15.5 15.5 14.8287 15.5 14V5C15.5 4.17125 14.8287 3.5 14 3.5H5ZM5 5H14V14H5V5Z",
    fill: "inherit",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.83eacaf4b1d0c6f098c0d872553593c3.svg";
export { ForwardRef as ReactComponent };